import createNetworkingClient from 'utils/networking-client';

export const types = {
  SET_DURATION: 'SET_DURATION',
  ADYEN_PRODUCT_CHECKOUT_REQUEST: 'ADYEN_PRODUCT_CHECKOUT_REQUEST',
  ADYEN_PRODUCT_CHECKOUT_SUCCESS: 'ADYEN_PRODUCT_CHECKOUT_SUCCESS',
  ADYEN_PRODUCT_CHECKOUT_FAILURE: 'ADYEN_PRODUCT_CHECKOUT_FAILURE',
  CLEAR_ADYEN_PRODUCT_CHECKOUT_ERROR: 'CLEAR_ADYEN_PRODUCT_CHECKOUT_ERROR',
  CHECK_PROMO_CODE_REQUEST: 'CHECK_PROMO_CODE_REQUEST',
  CHECK_PROMO_CODE_SUCCESS: 'CHECK_PROMO_CODE_SUCCESS',
  CHECK_PROMO_CODE_FAILURE: 'CHECK_PROMO_CODE_FAILURE',
  REMOVE_PROMO_CODE_REQUEST: 'REMOVE_PROMO_CODE_REQUEST',
  REMOVE_PROMO_CODE_SUCCESS: 'REMOVE_PROMO_CODE_SUCCESS',
  REMOVE_PROMO_CODE_FAILURE: 'REMOVE_PROMO_CODE_FAILURE',
  TOGGLE_PROMO_CODE_INPUT_VISIBILITY: 'TOGGLE_PROMO_CODE_INPUT_VISIBILITY',
  APP_PROPS_REFRESH_REQUEST: 'APP_PROPS_REFRESH_REQUEST',
  APP_PROPS_REFRESH_SUCCESS: 'APP_PROPS_REFRESH_SUCCESS',
  APP_PROPS_REFRESH_FAILURE: 'APP_PROPS_REFRESH_FAILURE',
  APP_PROPS_ORGANIC_REFRESH_SUCCESS: 'APP_PROPS_ORGANIC_REFRESH_SUCCESS'
};

export const setYearlyDuration = () => ({
  type: types.SET_DURATION,
  duration: 'yearly'
});

export const setMonthlyDuration = () => ({
  type: types.SET_DURATION,
  duration: 'monthly'
});

export const postAdyenProductCheckoutRequest = () => ({
  type: types.ADYEN_PRODUCT_CHECKOUT_REQUEST
});

export const postAdyenProductCheckoutSuccess = () => ({
  type: types.ADYEN_PRODUCT_CHECKOUT_SUCCESS
});

export const postAdyenProductCheckoutFailure = () => ({
  type: types.ADYEN_PRODUCT_CHECKOUT_FAILURE
});

export const clearCheckoutError = () => ({
  type: types.CLEAR_ADYEN_PRODUCT_CHECKOUT_ERROR
});

export const postAdyenProductCheckout = (postData, state, dispatch) => {
  dispatch(postAdyenProductCheckoutRequest());
  const { priceId: priceIdMonthly } = state.products.monthly;
  const { priceId: priceIdYearly } = state.products.yearly;
  const data = {
    ...postData,
    price_id_monthly: priceIdMonthly,
    price_id_yearly: priceIdYearly
  };
  const instance = createNetworkingClient({ timeout: 30000 });
  return instance
    .post('/adyen/api_product_checkout', data)
    .then((response) => {
      if (response && response.data.success) {
        dispatch(postAdyenProductCheckoutSuccess());
      } else {
        dispatch(postAdyenProductCheckoutFailure());
      }
    })
    .catch(() => {
      dispatch(postAdyenProductCheckoutFailure());
    });
};

export const postAdyenTrialCheckout = (postData, state, dispatch) => {
  dispatch(postAdyenProductCheckoutRequest());
  const { priceId: priceIdMonthly } = state.products.monthly;
  const { priceId: priceIdYearly } = state.products.yearly;
  const data = {
    ...postData,
    price_id_monthly: priceIdMonthly,
    price_id_yearly: priceIdYearly
  };
  const instance = createNetworkingClient({ timeout: 30000 });
  return instance
    .post('/adyen/api_product_trial_checkout', data)
    .then((response) => {
      if (response && response.data.success) {
        dispatch(postAdyenProductCheckoutSuccess());
      } else {
        dispatch(postAdyenProductCheckoutFailure());
      }
    })
    .catch(() => {
      dispatch(postAdyenProductCheckoutFailure());
    });
};

export const postCheckPromoCodeRequest = () => ({
  type: types.CHECK_PROMO_CODE_REQUEST
});

export const postCheckPromoCodeSuccess = (data) => ({
  type: types.CHECK_PROMO_CODE_SUCCESS,
  payload: data
});

export const postCheckPromoCodeFailure = () => ({
  type: types.CHECK_PROMO_CODE_FAILURE
});

export const postCheckPromoCode = (postData, dispatch) => {
  dispatch(postCheckPromoCodeRequest());

  return createNetworkingClient({ timeout: 300000 })
    .post('/premium/check_promo', { ...postData })
    .then((response) => {
      if (response && response.data.success) {
        dispatch(postCheckPromoCodeSuccess(response.data));
      } else {
        dispatch(postCheckPromoCodeFailure());
      }
    })
    .catch(() => {
      dispatch(postCheckPromoCodeFailure());
    });
};

export const postRemovePromoCodeRequest = () => ({
  type: types.REMOVE_PROMO_CODE_REQUEST
});

export const postRemovePromoCodeSuccess = (data) => ({
  type: types.REMOVE_PROMO_CODE_SUCCESS,
  payload: data
});

export const postRemovePromoCodeFailure = () => ({
  type: types.REMOVE_PROMO_CODE_FAILURE
});

export const togglePromoCodeInputVisibility = () => ({
  type: types.TOGGLE_PROMO_CODE_INPUT_VISIBILITY
});

export const postRemovePromoCode = (postData, dispatch) => {
  dispatch(postRemovePromoCodeRequest());

  return createNetworkingClient({ timeout: 300000 })
    .post('/premium/remove_promo', { ...postData })
    .then((response) => {
      if (response && response.data.success) {
        dispatch(postRemovePromoCodeSuccess(response.data));
      } else {
        dispatch(postRemovePromoCodeFailure());
      }
    })
    .catch(() => {
      dispatch(postRemovePromoCodeFailure());
    });
};

export const getNewProductRequest = () => ({
  type: types.APP_PROPS_REFRESH_REQUEST
});

export const getNewProductSuccess = (data) => ({
  type: types.APP_PROPS_REFRESH_SUCCESS,
  payload: data
});

export const getNewOrganicProductSuccess = (data) => ({
  type: types.APP_PROPS_ORGANIC_REFRESH_SUCCESS,
  payload: data
});

export const getNewProductFailure = () => ({
  type: types.APP_PROPS_REFRESH_FAILURE
});

export const getOrganicProduct = (state, dispatch) => {
  dispatch(getNewProductRequest());

  const { priceId: priceIdMonthly } = state.products.monthly;
  const { priceId: priceIdYearly } = state.products.yearly;
  const data = {
    price_id_yearly: priceIdYearly,
    price_id_monthly: priceIdMonthly,
    organic: true
  };
  return createNetworkingClient({ timeout: 300000 })
    .get('/subscribe/checkout', { params: data })
    .then((response) => {
      if (response && response.data.success) {
        dispatch(getNewOrganicProductSuccess(response.data.checkout_app_props));
      } else {
        dispatch(getNewProductFailure());
      }
    })
    .catch(() => {
      dispatch(getNewProductFailure());
    });
};

export const getTrialProduct = (state, dispatch) => {
  dispatch(getNewProductRequest());
  const { priceId: priceIdMonthly } = state.products.monthly;
  const { priceId: priceIdYearly } = state.products.yearly;
  const data = {
    price_id_yearly: priceIdYearly,
    price_id_monthly: priceIdMonthly
  };
  return createNetworkingClient({ timeout: 300000 })
    .get('/subscribe/checkout', { params: data })
    .then((response) => {
      if (response && response.data.success) {
        dispatch(getNewProductSuccess(response.data.checkout_app_props));
      } else {
        dispatch(getNewProductFailure());
      }
    })
    .catch(() => {
      dispatch(getNewProductFailure());
    });
};

export default {
  types,
  setYearlyDuration,
  setMonthlyDuration,
  postAdyenProductCheckout,
  postAdyenTrialCheckout,
  togglePromoCodeInputVisibility
};
